(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var cards = document.querySelectorAll('.product-card-wrap');
  cards.forEach(function(card, i) {
    card.style.setProperty('--index', i);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  var header = document.getElementById('SiteHeader');
  var announcementBar = document.getElementById('AnnouncementBar');
  var searchToggles = document.querySelectorAll('#SearchToggle, #SearchToggleMobile');
  var searchPanel = document.getElementById('SearchPanel');
  var searchClose = document.getElementById('SearchClose');
  var menuToggle = document.getElementById('MenuToggle');
  var mobileMenu = document.getElementById('MobileMenu');
  var mobileMenuClose = document.getElementById('MobileMenuClose');
  var overlay = document.getElementById('MobileMenuOverlay');

  /* Seuil : hauteur du bandeau + un peu de marge */
  var barHeight = announcementBar ? announcementBar.offsetHeight : 40;
  var SCROLL_THRESHOLD = barHeight + 10;

  /* Pages sans hero (pas de vidéo) → header toujours noir sur blanc */
  var hasHero = !!document.querySelector('.hero');

  function updateHeaderScrollState() {
    var scrolled = !hasHero || window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle('scrolled', scrolled);
    if (announcementBar) {
      announcementBar.classList.toggle('is-hidden', scrolled);
    }
  }

  /* Synchroniser aussi les pages chargées ou restaurées après défilement. */
  updateHeaderScrollState();
  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });
  window.addEventListener('pageshow', updateHeaderScrollState);

  if (searchToggles.length) {
    searchToggles.forEach(function(searchToggle) {
      searchToggle.addEventListener('click', function() {
        var isOpen = searchPanel.classList.toggle('is-open');
        searchPanel.setAttribute('aria-hidden', !isOpen);
        searchToggles.forEach(function(toggleButton) {
          toggleButton.setAttribute('aria-expanded', isOpen);
        });
        if (isOpen) {
          searchPanel.querySelector('input').focus();
        }
      });
    });
  }

  if (searchClose) {
    searchClose.addEventListener('click', function() {
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchToggles.forEach(function(toggleButton) {
        toggleButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function openMenu() {
    mobileMenu.classList.add('is-open');
    overlay.classList.add('is-visible');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.qty-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = btn.dataset.key;
      var action = btn.dataset.action;
      var valueEl = btn.closest('.cart-item__qty').querySelector('.qty-value');
      var current = parseInt(valueEl.textContent, 10);
      var next = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      valueEl.textContent = next;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: next })
      }).then(function() { window.location.reload(); });
    });
  });

  document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var key = btn.dataset.key;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function() { window.location.reload(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* ── Guide des tailles ─────────────────────────────────────── */
  var sgTrigger = document.getElementById('SizeGuideTrigger');
  var sgPanel   = document.getElementById('SizeGuidePanel');
  var sgClose   = document.getElementById('SizeGuideClose');
  var sgOverlay = document.getElementById('SizeGuideOverlay');

  function openSG() {
    if (!sgPanel) return;
    sgPanel.classList.add('is-open');
    sgPanel.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (sgClose) sgClose.focus();
  }
  function closeSG() {
    if (!sgPanel) return;
    sgPanel.classList.remove('is-open');
    sgPanel.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (sgTrigger) sgTrigger.focus();
  }
  if (sgTrigger) sgTrigger.addEventListener('click', openSG);
  if (sgClose)   sgClose.addEventListener('click', closeSG);
  if (sgOverlay) sgOverlay.addEventListener('click', closeSG);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sgPanel && sgPanel.classList.contains('is-open')) closeSG();
  });

  /* ── Lightbox avec zoom panning ────────────────────────────── */
  var lightbox  = document.getElementById('ProductLightbox');
  var lbImg     = document.getElementById('LightboxImg');
  var lbClose   = document.getElementById('LightboxClose');
  var lbPrev    = document.getElementById('LightboxPrev');
  var lbNext    = document.getElementById('LightboxNext');
  var lbCounter = document.getElementById('LightboxCounter');
  var lbHint    = document.getElementById('LightboxHint');
  var items     = Array.from(document.querySelectorAll('.product-gallery__item'));
  var lbIndex   = 0;

  /* — état zoom — */
  var LB_SCALE   = 3.2;
  var lbZoomed   = false;
  var lbTx       = 0;
  var lbTy       = 0;
  var lbDragging = false;
  var lbDragDidMove = false;
  var lbDragStart   = { x: 0, y: 0 };
  var lbTxStart     = 0;
  var lbTyStart     = 0;

  function applyTransform(animate) {
    if (!animate) lbImg.classList.add('is-dragging');
    else          lbImg.classList.remove('is-dragging');
    if (lbZoomed) {
      lbImg.style.transform = 'scale(' + LB_SCALE + ') translate(' + (lbTx / LB_SCALE) + 'px,' + (lbTy / LB_SCALE) + 'px)';
    } else {
      lbImg.style.transform = '';
    }
  }

  function resetZoom() {
    lbZoomed = false;
    lbTx = 0; lbTy = 0;
    lbImg.classList.remove('is-zoomed', 'is-dragging');
    lbImg.style.transformOrigin = 'center center';
    applyTransform(true);
    if (lbHint) lbHint.classList.remove('is-hidden');
  }

  /* clic sur l'image : zoom / dézoom */
  lbImg.addEventListener('click', function(e) {
    if (lbDragDidMove) return; /* était un drag, pas un clic */
    if (!lbZoomed) {
      /* calcule l'origine du zoom au point cliqué */
      var rect = lbImg.getBoundingClientRect();
      var ox = ((e.clientX - rect.left) / rect.width  * 100).toFixed(1);
      var oy = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1);
      lbImg.style.transformOrigin = ox + '% ' + oy + '%';
      lbTx = 0; lbTy = 0;
      lbZoomed = true;
      lbImg.classList.add('is-zoomed');
      applyTransform(true);
      if (lbHint) lbHint.classList.add('is-hidden');
    } else {
      resetZoom();
    }
  });

  /* drag to pan */
  lbImg.addEventListener('mousedown', function(e) {
    if (!lbZoomed) return;
    e.preventDefault();
    lbDragging = true;
    lbDragDidMove = false;
    lbDragStart.x = e.clientX;
    lbDragStart.y = e.clientY;
    lbTxStart = lbTx;
    lbTyStart = lbTy;
  });
  window.addEventListener('mousemove', function(e) {
    if (!lbDragging) return;
    var dx = e.clientX - lbDragStart.x;
    var dy = e.clientY - lbDragStart.y;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) lbDragDidMove = true;
    lbTx = lbTxStart + dx;
    lbTy = lbTyStart + dy;
    applyTransform(false);
  });
  window.addEventListener('mouseup', function() {
    if (!lbDragging) return;
    lbDragging = false;
    lbImg.classList.remove('is-dragging');
  });

  /* touch pinch-to-zoom natif : retirer les contraintes max sur mobile */
  lbImg.addEventListener('touchstart', function() {}, { passive: true });

  function openLightbox(index) {
    if (!lightbox || !items.length) return;
    lbIndex = index;
    resetZoom();
    showLbImage();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    resetZoom();
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  function showLbImage() {
    var item = items[lbIndex];
    if (!item) return;
    lbImg.src = item.dataset.src || item.querySelector('img').src;
    lbImg.alt = item.dataset.alt || '';
    if (lbCounter) lbCounter.textContent = (lbIndex + 1) + ' / ' + items.length;
    var single = items.length <= 1;
    if (lbPrev) lbPrev.style.display = single ? 'none' : '';
    if (lbNext) lbNext.style.display = single ? 'none' : '';
  }

  items.forEach(function(item, i) {
    item.addEventListener('click', function() { openLightbox(i); });
  });
  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev)  lbPrev.addEventListener('click', function() {
    resetZoom();
    lbIndex = (lbIndex - 1 + items.length) % items.length;
    showLbImage();
  });
  if (lbNext)  lbNext.addEventListener('click', function() {
    resetZoom();
    lbIndex = (lbIndex + 1) % items.length;
    showLbImage();
  });
  if (lightbox) lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });
  document.addEventListener('keydown', function(e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (e.key === 'ArrowLeft')  { resetZoom(); lbIndex = (lbIndex - 1 + items.length) % items.length; showLbImage(); }
    if (e.key === 'ArrowRight') { resetZoom(); lbIndex = (lbIndex + 1) % items.length; showLbImage(); }
  });

  /* ── Hover zoom 2× sur les photos de la galerie ───────────── */
  document.querySelectorAll('.product-gallery__item').forEach(function(item) {
    var img = item.querySelector('.product-gallery__img');
    if (!img) return;

    function setOrigin(e) {
      var rect = item.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(2);
      var y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(2);
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    item.addEventListener('mouseenter', function(e) {
      setOrigin(e);
      img.style.transition = 'transform 0.3s ease';
      item.classList.add('is-hovered');
    });

    item.addEventListener('mousemove', function(e) {
      /* mise à jour instantanée de l'origine pendant le zoom */
      img.style.transition = 'none';
      setOrigin(e);
    });

    item.addEventListener('mouseleave', function() {
      img.style.transition = 'transform 0.3s ease';
      item.classList.remove('is-hovered');
      img.style.transformOrigin = 'center center';
    });
  });

  /* ── Mobile : dots via IntersectionObserver ────────────────── */
  var stack = document.getElementById('GalleryStack');
  var dots  = document.querySelectorAll('.gallery-dot');

  if (stack && dots.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var i = parseInt(entry.target.dataset.index, 10);
          dots.forEach(function(d, di) { d.classList.toggle('is-active', di === i); });
        }
      });
    }, { root: stack, threshold: 0.6 });

    items.forEach(function(item) { observer.observe(item); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });
  }

  /* ── Variants ──────────────────────────────────────────────── */
  var form         = document.getElementById('ProductForm');
  var variantInput = document.getElementById('VariantId');
  if (!form) return;

  var productData = window.__productVariants || [];

  function getSelectedOptions() {
    return Array.from(form.querySelectorAll('.option-swatch__input:checked')).map(function(i) { return i.value; });
  }
  function findVariant(opts) {
    return productData.find(function(v) {
      return opts.every(function(o, i) { return v['option' + (i + 1)] === o; });
    });
  }

  var atcWrap       = document.getElementById('ProductAtcWrap');
  var notifyWrap    = document.getElementById('ProductNotify');
  var notifyVarId   = document.getElementById('NotifyVariantId');
  var notifyVarLbl  = document.getElementById('NotifyVariantLabel');
  var notifyVarBody = document.getElementById('NotifyVariantBody');
  var notifySuccVar = document.getElementById('NotifySuccessVariant');

  /* Le titre produit est lu depuis data-product-title sur #ProductNotify
     car {% javascript %} ne supporte pas l'interpolation Liquid. */
  var productTitle = (notifyWrap && notifyWrap.dataset.productTitle) || '';

  function updateAtcState(variant) {
    if (!variant) return;
    if (variant.available) {
      if (atcWrap)    atcWrap.style.display    = '';
      if (notifyWrap) notifyWrap.style.display = 'none';
    } else {
      if (atcWrap)    atcWrap.style.display    = 'none';
      if (notifyWrap) notifyWrap.style.display = '';
      if (notifyVarId) notifyVarId.value = variant.id;
      var sizeName = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
      if (notifyVarLbl)  notifyVarLbl.textContent  = sizeName ? 'taille ' + sizeName : '';
      if (notifyVarBody) notifyVarBody.value = productTitle + (sizeName ? ' — Taille : ' + sizeName : '') + ' (variant ID : ' + variant.id + ')';
      if (notifySuccVar) notifySuccVar.textContent = productTitle + (sizeName ? ' (' + sizeName + ')' : '');
    }
  }

  /* ── Signal stock & livraison par variante ── */
  var stockSignal    = document.getElementById('ProductStockSignal');
  var stockQty       = document.getElementById('ProductStockQty');
  var deliverySignal = document.getElementById('ProductDeliverySignal');
  var lowStockMap    = window.__variantLowStock || {};

  function updateStockSignal(variant) {
    if (!variant) return;
    var low = lowStockMap[variant.id] || 0;
    if (stockSignal) {
      if (variant.available && low > 0) {
        if (stockQty) stockQty.textContent = low;
        stockSignal.style.display = '';
      } else {
        stockSignal.style.display = 'none';
      }
    }
    if (deliverySignal) {
      deliverySignal.style.display = variant.available ? '' : 'none';
    }
  }

  form.querySelectorAll('.option-swatch__input').forEach(function(input) {
    input.addEventListener('change', function() {
      var label = input.closest('.option-swatch');
      label.closest('.product-option__values').querySelectorAll('.option-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
      label.classList.add('is-selected');
      var hdr = label.closest('.product-option').querySelector('.product-option__selected');
      if (hdr) hdr.textContent = input.value;
      var variant = findVariant(getSelectedOptions());
      if (variant && variantInput) variantInput.value = variant.id;
      updateAtcState(variant);
      updateStockSignal(variant);
    });
  });

  /* État initial : aligne les signaux sur la variante pré-sélectionnée. */
  updateStockSignal(findVariant(getSelectedOptions()));

  /* ──────────────────────────────────────────────────────────────────────
     Soumission « Me prévenir »
     Étape 1 (submit) : on laisse le browser soumettre nativement le
       {% form 'contact' %} vers l'iframe caché #NotifyContactSink.
       Shopify intercepte le submit, injecte le token hCaptcha invisible,
       et envoie réellement l'email à l'admin. Pas de fetch — c'est ce qui
       permet à la spam-protection Shopify de fonctionner.
       On affiche le succès UI immédiatement sans bloquer le submit natif.
     Étape 2 (clic « Recevoir code -10 % ») : ouvre le popup Club Bling
       pré-rempli avec l'email. L'utilisateur finalise l'inscription via
       le flow natif Shopify (form 'customer').
     ────────────────────────────────────────────────────────────────────── */
  var notifyForm     = document.getElementById('SoldOutNotificationForm');
  var notifyBody     = document.getElementById('NotifyBody');
  var notifySuccess  = document.getElementById('NotifySuccess');
  var notifyClubBtn  = document.getElementById('NotifyClubBtn');
  var notifiedEmail  = '';

  if (notifyForm) {
    notifyForm.addEventListener('submit', function() {
      var emailEl = document.getElementById('NotifyEmail');
      notifiedEmail = emailEl ? emailEl.value.trim() : '';

      if (notifyBody)    notifyBody.style.display    = 'none';
      if (notifySuccess) notifySuccess.style.display = '';
      /* Pas de preventDefault : le browser soumet nativement vers l'iframe.
         Shopify spam-protection injecte hCaptcha. */
    });
  }

  if (notifyClubBtn) {
    notifyClubBtn.addEventListener('click', function() {
      if (window.BlingNewsletter && typeof window.BlingNewsletter.open === 'function') {
        window.BlingNewsletter.open(notifiedEmail);
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
